import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PictureListComponent } from './picture-list.component';
import { SliderProModule } from '../slider-pro/slider-pro.module';
import { GridModule } from '../grid/grid.module';
import { PictureModule } from '../picture/picture.module';
import { TextModule } from '../text/text.module';
import { LoaderModule } from '@shopping-angular-components/loader';

@NgModule({
  declarations: [
    PictureListComponent
  ],
  imports: [
    CommonModule,
    SliderProModule,
    GridModule,
    PictureModule,
    TextModule,
    LoaderModule
  ],
  exports: [
    PictureListComponent
  ]
})
export class PictureListModule { }
